import script from "./AutomationCreateAutomation.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutomationCreateAutomation.vue?vue&type=script&setup=true&lang=ts"

import "./AutomationCreateAutomation.vue?vue&type=style&index=0&id=d46053a2&lang=scss"

const __exports__ = script;

export default __exports__